<template>
    <div class="confirm-container">
        <!-- 配置信息 -->
        <div class="instance-item">
            <div class="instance-item-left">
                <!-- <i class="icon-system-settings-o instance-item-icon"></i> -->
                <span>{{$t('配置信息')}}</span>
            </div>
            <div class="instance-item-right">
                <!-- 实例详情 -->
                <Row v-if="component === 'compute'">
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('云环境')}}：</span>
                        <span class="value"
                              :title="data.envData.envName+'/'+data.zoneData.name">{{data.envData.envName}} / {{data.zoneData.name}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('所属项目')}}：</span>
                        <span class="value"
                              :title="submitData.projectData.orgName||'--'">{{submitData.projectData.orgName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.chargeData">
                    <div class="show-item">
                        <span class="title">{{$t("计费方式")}}：</span>
                        <span class="value"
                              :title="data.chargeData.name||'--'">{{data.chargeData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('镜像')}}：</span>
                        <span class="value"
                              :title="data.imageData.name||'--'">{{data.imageData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('实例名称')}}：</span>
                        <span class="value"
                              :title="data.insData.name||'--'">{{data.insData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('实例类型')}}：</span>
                        <span class="value"
                              :title="data.insData.family?('（'+data.insData.family.familyName+'）'+data.insData.type.name):data.insData.type.name">
                            <span v-if="data.insData.family">（{{data.insData.family.familyName}}）</span>
                            {{data.insData.type.name}}
                        </span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.sysDiskData">
                    <div class="show-item">
                        <span class="title">{{$t('系统盘')}}：</span>
                        <span class="value"
                              :title="'（'+data.sysDiskData.category.name+'）'+data.sysDiskData.size+'GB'">（{{data.sysDiskData.category.name}}）{{data.sysDiskData.size}}GB</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('数据盘')}}：</span>
                        <span class="value"
                              :title="data.dataDiskData.length > 0 ? data.dataDiskData.length +$t('块') : $t('无')">
                            {{data.dataDiskData.length > 0 ? data.dataDiskData.length +$t('块') : $t('无')}}
                        </span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('网络')}}：</span>
                        <span class="value"
                              :title="data.networkData.vpc.name+'/'+data.networkData.subnet.name">{{data.networkData.vpc.name}} / {{data.networkData.subnet.name}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('安全组')}}：</span>
                        <span class="value"
                              :title="data.sgData.name||'--'">{{data.sgData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('登录方式')}}：</span>
                        <span class="value"
                              :title="data.loginData.loginType === 'ByPassword'?$t('密码'):$t('密钥')">{{data.loginData.loginType === 'ByPassword'?$t('密码'):$t('密钥')}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('用户名')}}/{{$t('密码')}}：</span>
                        <span class="value">
                            <span :title="data.loginData.userName">{{data.loginData.userName}} / </span>
                            <span :title="$t('自动生成密码')"
                                  v-if="data.loginData.loginType === 'ByPassword' && data.loginData.isAutoPasswd">{{$t('自动生成密码')}}</span>
                            <span :title="data.loginData.password"
                                  v-if="data.loginData.loginType === 'ByPassword' && !data.loginData.isAutoPasswd">{{data.loginData.password}}</span>
                            <span :title="data.loginData.keypair.name"
                                  v-if="data.loginData.loginType === 'ByKeypair' && data.loginData.isAutoPasswd">{{data.loginData.keypair.name}}</span>
                        </span>
                    </div>
                    </Col>
                </Row>
                <!-- 弹性IP -->
                <Row v-if="component === 'floatingIp'">
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('云环境')}}：</span>
                        <span class="value"
                              :title="data.envData.envName||'--'">{{data.envData.envName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.billingTypeData">
                    <div class="show-item">
                        <span class="title">{{$t('计费类型')}}：</span>
                        <span class="value"
                              :title="data.billingTypeData.name||'--'">{{data.billingTypeData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.bandwidthData">
                    <div class="show-item">
                        <span class="title">{{$t('带宽')}}：</span>
                        <span class="value"
                              :title="data.bandwidthData+'（Mbit/s）'">{{data.bandwidthData}}（Mbit/s）</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.shareTypeData">
                    <div class="show-item">
                        <span class="title">{{$t('带宽类型')}}：</span>
                        <span class="value"
                              :title="data.shareTypeData.name||'--'">{{data.shareTypeData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.networkTypeData">
                    <div class="show-item">
                        <span class="title">{{$t('网络类型')}}：</span>
                        <span class="value"
                              :title="data.networkTypeData.name||'--'">{{data.networkTypeData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.pool">
                    <div class="show-item">
                        <span class="title">{{$t('资源池')}}：</span>
                        <span class="value"
                              :title="data.pool.name||'--'">{{data.pool.name||'--'}}</span>
                    </div>
                    </Col>
                </Row>
                <!-- 硬盘 -->
                <Row v-if="component === 'disk'">
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('云环境')}}：</span>
                        <span class="value"
                              :title="data.envData.envName||'--'">{{data.envData.envName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('可用区')}}：</span>
                        <span class="value"
                              :title="data.zoneData.name||'--'">{{data.zoneData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('名称')}}：</span>
                        <span class="value"
                              :title="data.storageName||'--'">{{data.storageName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('存储类型')}}：</span>
                        <span class="value"
                              :title="data.storageTypeData.name||'--'">{{data.storageTypeData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('存储大小')}}：</span>
                        <span class="value"
                              :title="data.diskSize+'（GB）'">{{data.diskSize}}（GB）</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="data.shareDisk">
                    <div class="show-item">
                        <span class="title">{{$t('共享')}}：</span>
                        <span class="value"
                              :title="data.shareDisk === 'share'?$t('是'):$t('否')">{{data.shareDisk === 'share'?$t('是'):$t('否')}}</span>
                    </div>
                    </Col>
                </Row>
                <!-- 其他服务 -->
                <Row v-if="component === 'otherService'">
                    <Col span="12">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('申请描述')}}：</span>
                        <span class="value"
                              :title="data.description || '--'">{{data.description || '--'}}</span>
                    </div>
                    </Col>
                </Row>
                <!-- hpc高性能计算 -->
                <Row v-if="['HPC', 'HPC-SAAS'].includes(component)">
                    <Col span="24"
                         v-show="$store.state.app.cloudConfigShow">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('云环境')}}：</span>
                        <span class="value"
                              :title="data.envData.envName||'--'">{{data.envData.envName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="24"
                         v-if="data.availableZonesData.name">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('可用区')}}：</span>
                        <span class="value"
                              :title="data.availableZonesData.name||'--'">{{data.availableZonesData.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="24">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('计费方式')}}：</span>
                        <span class="value"
                              :title="data.chargeData.name">{{data.chargeData.name}}</span>
                    </div>
                    </Col>
                    <Col span="24">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('资源池')}}：</span>
                        <span class="value"
                              :title="data.poolData.name">{{data.poolData.name}}</span>
                    </div>
                    </Col>
                    <Col span="24">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('CPU规格')}}：</span>
                        <span class="value"
                              :title="data.cpuSpecificationData.name">{{data.cpuSpecificationData.name}}</span>
                    </div>
                    </Col>
                    <Col span="24">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('GPU规格')}}：</span>
                        <span class="value"
                              :title="data.gpuSpecificationData.name">{{data.gpuSpecificationData.name}}</span>
                    </div>
                    </Col>
                    <Col span="24">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('存储大小')}}：</span>
                        <span class="value"
                              :title="data.hpcSize">{{data.hpcSize}}&nbsp;GB</span>
                    </div>
                    </Col>
                </Row>
                <!-- 内置 -->
                <Row v-if="['innerService','sefService'].includes(component)&& templateType !== 'HPC-DRP'">
                    <Col span="8"
                         v-if="!['HPC', 'HPC-SAAS'].includes(templateType)">
                    <div class="show-item">
                        <span class="title">{{$t('所属项目')}}：</span>
                        <span class="value"
                              :title="submitData.projectData.orgName||'--'">{{submitData.projectData.orgName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="baseForm&&baseForm.name&&baseForm.name.length>0&&!['HPC', 'HPC-SAAS'].includes(templateType)">
                    <div class="show-item">
                        <span class="title">{{$t('名称')}}：</span>
                        <span class="value"
                              :title="baseForm.name||'--'">{{baseForm.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col v-for="(item,index) in submitData.templatesData"
                         :key="index"
                         span="8">
                    <div class="show-item"
                         v-if="item.options.label && dynamicVisible(item.rules.dynamicVisibleValue)">
                        <span class="title"
                              :title="$t(item.options.label)">{{$t(item.options.label)}}：</span>
                        <span class="value"
                              :title="value(item)">{{ value(item)||'--'}}
                            <!--弹性文件服务的容量加单位GB-->
                            {{templateType === 'SFS2.0'&&item.options.attrKey=='capacity'?'GB':''}}
                            <!--HPC共享资源池默认存储大小、存储大小加单位GB-->
                            {{['HPC', 'HPC-SAAS'].includes(templateType)&&['size','capacity'].includes(item.options.attrKey)?'GB':''}}
                            <template v-if="(['DRP'].includes(templateType)&&item.options.attrKey=='count') && pflopsText">（{{pflopsText}}）</template>
                        </span>
                    </div>
                    </Col>
                </Row>
                <!-- HPC-DRP 等新的数据结构 -->
                <Row v-if="templateType === 'HPC-DRP'">
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('所属项目')}}：</span>
                        <span class="value"
                              :title="submitData.projectData.orgName||'--'">{{submitData.projectData.orgName||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8"
                         v-if="baseForm&&baseForm.name&&baseForm.name.length>0">
                    <div class="show-item">
                        <span class="title">{{$t('资源池名称')}}：</span>
                        <span class="value"
                              :title="baseForm.name||'--'">{{baseForm.name||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('集群类型')}}：</span>
                        <span class="value"
                              :title="clusterTypeName||'--'">{{clusterTypeName||'--'}}</span>
                    </div>
                    </Col>
                    <template v-for="(item,index) in submitData.templatesData">
                        <Col :span="item.chidrenDesc ? 24 : 8"
                             v-if="item.label && !item.isHidden&&(item.chidrenDesc?(item.chidrenDesc[0]&&item.chidrenDesc[0][0]&&item.chidrenDesc[0][0].isShow):true)"
                             :key="index">
                        <div class="show-item"
                             :key="index">
                            <span class="title"
                                  :title="$t(item.label)">{{$t(item.label)}}：</span>
                            <span class="value">
                                <span v-if="item.chidrenDesc && item.chidrenDesc.length>0">
                                    <span style="display: block;"
                                          v-for="(element, index) in item.chidrenDesc"
                                          :key="index">
                                        <template v-for="(elementItem, indexy) in element"
                                                  v-if="elementItem.isShow">
                                            <span :key="elementItem.label + indexy"
                                                  class="mar-right10">{{elementItem.label}} </span>
                                            <span :key="elementItem.label"
                                                  class="mar-right10"> {{elementItem.value || '--'}}
                                                <span class="mar-left10"
                                                      v-if="indexy !== 1">|</span>
                                            </span>
                                        </template>
                                    </span>
                                </span>
                                <span v-else> {{comTxt(item) }}</span>
                            </span>
                        </div>
                        </Col>
                    </template>
                </Row>
            </div>
        </div>
        <!-- 数量&时长 -->
        <div v-if="!['innerService','sefService','HPC', 'HPC-SAAS'].includes(component) "
             class="instance-item"
             style="border-bottom:0px">
            <div class="instance-item-left">
                <!-- <i class="icon-duration instance-item-icon"></i> -->
                <span>{{$t('数量')}}&{{$t('时长')}}</span>
            </div>
            <div class="instance-item-right">
                <Form ref="timeForm"
                      :model="formData"
                      :rules="rules"
                      :label-colon="true"
                      :hide-required-mark="false"
                      label-position="right"
                      :label-width="80">
                    <!-- 数量 -->
                    <FormItem :label="$t('购买数量')">
                        <InputNumber v-model="formData.count"
                                     :min="1"
                                     :max="5"
                                     :active-change="false"
                                     @on-change="changeTimeCount"></InputNumber>
                    </FormItem>
                    <!-- 申请时长, 创建主机时，按量计费不显示 -->
                    <FormItem :label="$t('时长')"
                              v-if="showTime ||  ['innerService','sefService'].includes(component)">
                        <RadioGroup type="button"
                                    v-model="formData.time"
                                    @on-change="changeTimeCount">
                            <Radio v-for="(item,index) in productTimeList"
                                   :key="index"
                                   :label="item.value">{{item.label}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem v-if="showCoupon ||['innerService','sefService'].includes(component)">
                        <Checkbox v-model="formData.isCoupon"
                                  @on-change="changeCoupon">{{$t('使用优惠券')}}</Checkbox>
                        <Select style="width:200px;margin-left:20px;"
                                v-if="formData.isCoupon"
                                v-model="formData.couponId"
                                :transfer="true"
                                clearable
                                @on-change="changeCouponValue">
                            <Option v-for="(item, index) in couponData"
                                    :key="index"
                                    :disabled="item.discountAmount > parseInt(tradePrice)||item.reductionCondition> parseInt(tradePrice)"
                                    :value="item.couponSid">{{item.text}}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>
        </div>
        <div v-if="templateType==='ModelArts'"
             class="instance-item">
            <div class="instance-item-left"><i class="icon-cost-center-o instance-item-icon"></i><span>{{$t('价格列表')}}</span></div>
            <div class="instance-item-right">
                <p>{{$t('ModelArts价格表')}}：</p>
                <modelArtsTable v-if="priceData"
                                :priceData="priceData"
                                templateType="ModelArts"></modelArtsTable>
                <br />
                <p>{{$t('对象存储价格表')}}：</p>
                <modelArtsTable v-if="priceData"
                                :priceData="priceData"
                                templateType="OBS"></modelArtsTable>
            </div>
        </div>
        <!-- 专属资源池优惠券 -->
        <div class="instance-item"
             v-if="showCoupon"
             style="border-bottom:0;border-top: 10px solid #f5f6f7;">
            <div class="instance-item-left"
                 style="padding-top:8px;">
                <!-- <i class="icon-duration instance-item-icon"></i> -->
                <span>{{$t('优惠券')}}</span>
            </div>
            <div class="instance-item-right">
                <Form ref="timeForm"
                      :model="formData"
                      :rules="rules"
                      :label-colon="true"
                      :hide-required-mark="false"
                      label-position="right"
                      :label-width="35">
                    <FormItem v-if="showCoupon"
                              style="margin-bottom: 10px;">
                        <Checkbox v-model="formData.isCoupon"
                                  @on-change="changeCoupon">{{$t('使用优惠券')}}</Checkbox>
                        <Select style="width:200px;margin-left:20px;"
                                v-if="formData.isCoupon"
                                v-model="formData.couponId"
                                :transfer="true"
                                clearable
                                @on-clear="clearCouponValue"
                                @on-change="changeCouponValue">
                            <Option v-for="(item, index) in couponData"
                                    :key="index"
                                    :disabled="(item.discountAmount > parseInt(tradePrice)&&!['AI','DRP','HPC-DRP','IAAS','SFS2.0'].includes(templateType))||item.reductionCondition> parseInt(tradePrice)"
                                    :value="item.couponSid">{{item.text}}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>
        </div>
        <discountmodal ref="discountmodal"
                       :titleTxt="$t('确定要继续购买吗？') "
                       :contentTxt="$t('您使用的优惠券金额大于订单金额，超出的优惠金额将不退还。')"
                       @modalFun="modalFun"></discountmodal>
    </div>
</template>

<script>
import { formatDateTime } from '@/service/utils'
import API from '@/service/api.js'
import modelArtsTable from '@/views/portal/application/components/inner/model-arts-table.vue'
import discountmodal from '@/views/portal/application/components/discountmodal.vue'
import innerServiceMixin from '@/mixin/innerServiceMixin.js'
export default {
    name: 'InfoConfirm',
    props: ['component', 'submitData', 'templateType', 'priceData', 'baseForm', 'notBilled', 'clusterTypeName', 'pflopsText'],
    components: {
        modelArtsTable,
        discountmodal
    },
    data () {
        return {
            data: this.submitData.zeroData,
            formData: this.submitData.oneData,
            couponData: [],
            rules: {},
            templatesData: this.submitData.templatesData
        }
    },
    created () {
        // if (this.formData.isCoupon) {
        //     this.changeCoupon()
        // } else {
        this.formData.isCoupon = false
        this.formData.couponId = null
        this.formData.discount = null
        // }
        this.inquiry()
    },
    mixins: [innerServiceMixin],
    computed: {
        tradePrice () {
            return this.submitData.tradePrice
        },
        showCoupon () {
            let isPrePaid = false // bug25401，包年包月才能使用优惠券
            if (this.submitData && this.submitData.zeroData && this.submitData.zeroData.chargeData && this.submitData.zeroData.chargeData.value && this.submitData.zeroData.chargeData.value === 'PrePaid') {
                isPrePaid = true
            }
            if (this.submitData.zeroData.chargeType === 'PrePaid') {
                isPrePaid = true
            }
            // 金额必须要大于0 && （私有云实例创建 || 第三方服务）
            // const isEnvPrivateAndCompute = ['compute', 'floatingIp', 'disk'].includes(this.component) && !(this.$isNullOrEmpty(this.data.envData) ? false : this.data.envData.isPublic)
            const isEnvPrivateAndCompute = ['compute', 'floatingIp', 'disk', 'otherService', 'innerService', 'sefService'].includes(this.component) // 公有云，私有云都能使用优惠券，bug19753
            return (isEnvPrivateAndCompute || this.templateType === 'DRP' || this.templateType === 'IAAS') && isPrePaid && !this.notBilled
        },
        showTime () {
            const isPrePaid = this.data.chargeData && this.data.chargeData.value === 'PrePaid'
            // const isPublic = this.$isNullOrEmpty(this.data.envData) ? false : this.data.envData.isPublic
            return ['compute', 'floatingIp', 'disk', 'innerService', 'sefService'].includes(this.component) && isPrePaid
        }
    },
    methods: {
        // 传递的值
        value (item) {
            if (item.options.defaultData) {
                const data = item.options.defaultData.filter(el => el.value === item.options.defaultValue)[0]
                if (['radio', 'select'].includes(item.type)) {
                    return data ? data.label : '--'
                }
                if (['calculation'].includes(item.type)) {
                    return data ? (data.type + '/' + data.specifications) : '--'
                }
            }
            if (item.attrKey === 'time') {
                return (this.data[item.options.attrKey] && this.data[item.options.attrKey].toString() + '月') || '--'
            }
            return (this.data[item.options.attrKey] && this.data[item.options.attrKey].toString()) || '--'
        },
        // TODO:HPC传递的值
        getValue (item) {
            if (item.defaultData) {
                const data = item.defaultData.filter(el => el.value === this.data[item.attrKey])[0]
                if (['radio', 'select'].includes(item.type)) {
                    return data ? data.label : '--'
                }
                if (['calculation'].includes(item.type)) {
                    return data ? (data.type + '/' + data.specifications) : '--'
                }
            }
            if (item.attrKey === 'time') {
                return (this.data[item.attrKey] && this.data[item.attrKey].toString() + '月') || '--'
            }
            return (this.data[item.attrKey] && this.data[item.attrKey].toString()) || '--'
        },
        dynamicVisible (value) {
            if (!value) {
                return true
            }
            this.data.chargeType = this.data.chargeData.value
            const result = this._dynamicFun(value, this.data)
            return result
        },
        changeCoupon () {
            this.formData.couponId = null
            this.formData.discount = null
            this.couponData = []
            if (this.formData.isCoupon) {
                const time = new Date()
                this.axios.get(this.urlFormat(API.COUPONS_ACCOUNTS), {
                    params: {
                        categoryId: this.$route.params.id,
                        couponStatus: 'unused',
                        startTimeLe: time ? formatDateTime(time) : '',
                        endTimeGe: time ? formatDateTime(time) : ''
                    }
                }).then((result) => {
                    if (result.dataList && result.dataList.length > 0) {
                        // 过滤满足当前价格的优惠券
                        const newList = result.dataList.filter((item) => {
                            return item
                            // return (!item.reductionCondition) || (item.reductionCondition > 0 && item.reductionCondition <= parseInt(this.submitData.tradePrice))
                        })
                        newList.forEach(item => {
                            item.text = item.reductionCondition ? '（' + this.$t('满') + item.reductionCondition + this.$t('减') + item.discountAmount + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券') : '（' + this.$t('无限制') + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券')
                        })
                        this.couponData = newList
                        // 包年包月才能使用优惠券
                        if (newList.length > 0 && this.submitData && this.submitData.zeroData && this.submitData.zeroData.chargeData && this.submitData.zeroData.chargeData.value && this.submitData.zeroData.chargeData.value === 'PrePaid') {
                            // this.formData.couponId = newList[0].couponSid
                            // this.formData.discount = newList[0].discountAmount
                        } else {
                            this.formData.couponId = null
                            this.formData.discount = null
                        }
                        // this.inquiry()
                    } else {
                        this.couponData = []
                        this.formData.couponId = null
                        this.formData.discount = null
                        this.inquiry()
                    }
                })
            } else {
                // this.formData.couponId = this.formData.couponId || this.$isNullOrEmpty(this.couponData) ? null : this.couponData[0].couponSid
                // this.formData.discount = this.formData.discount || this.$isNullOrEmpty(this.couponData) ? 0 : this.couponData[0].discountAmount
                this.inquiry()
            }
        },
        clearCouponValue () {
            this.formData.couponId = null
            this.formData.discount = null
            this.inquiry()
        },
        changeCouponValue () {
            const data = this.getOne(this.formData.couponId, this.couponData, 'couponSid')
            this.formData.discount = data ? data.discountAmount : null
            if (data && data.discountAmount && ['AI', 'DRP', 'HPC-DRP', 'IAAS', 'SFS2.0'].includes(this.templateType) && data.discountAmount > this.tradePrice) {
                this.$refs.discountmodal.openModal()
            } else {
                // 优惠券小于总金额时，直接询价
                this.inquiry()
            }
        },
        modalFun () {
            const data = this.getOne(this.formData.couponId, this.couponData, 'couponSid')
            this.formData.discount = data ? data.discountAmount : null
            this.$nextTick(() => {
                this.inquiry()
            })
        },
        changeTimeCount () {
            this.inquiry(() => {
                if (this.showCoupon && this.formData.isCoupon) {
                    this.axios.get(this.urlFormat(API.COUPONS_ACCOUNTS), {
                        params: {
                            couponStatus: 'unused',
                            categoryId: this.$route.params.id
                        }
                    }).then((result) => {
                        if (result.dataList && result.dataList.length > 0) {
                            let defaultCoupon = {}
                            // 解决购买时长切换的时候， 某些大额优惠券在切换后不满足使用条件，但优惠券ID未发生改变的情况
                            // 过滤满足当前价格的优惠券
                            const newList = result.dataList.filter((item) => {
                                const condition = (!item.reductionCondition) || (item.reductionCondition > 0 && item.reductionCondition <= parseInt(this.submitData.tradePrice))
                                if (condition && item.couponSid === this.formData.couponId) {
                                    defaultCoupon = item
                                }
                                return condition
                            })
                            newList.forEach(item => {
                                item.text = item.reductionCondition ? '（' + this.$t('满') + item.reductionCondition + this.$t('减') + item.discountAmount + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券') : '（' + this.$t('无限制') + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券')
                            })
                            this.couponData = newList
                            // this.formData.couponId = defaultCoupon.couponSid || ''
                            // this.formData.discount = defaultCoupon.discountAmount || ''
                            this.changeCouponValue()
                        } else {
                            this.couponData = []
                            this.formData.couponId = null
                            this.formData.discount = null
                        }
                    }).catch(() => {
                    })
                }
            })
        },
        inquiry (callback) {
            if (!this.showTime) {
                this.formData.time = null
            }
            this.$emit('inquiry', this.formData, 'one', callback)
        },
        comTxt (item) {
            if (item.attrKey === 'clusterPackage') {
                return item.value.clusterName
            }
            if (item.attrKey === 'storageInfoTable') {
                const name = item.value.map(item => (item.ShareInfo[0].DPCShareName || '').replace(/\//g, ''))
                return name.join(',')
            }
            return Array.isArray(item.desc) ? item.desc.join('，') : (item.desc.value || '--')
        }
    }
}
</script>

<style lang="less" scoped>
.confirm-container {
    .instance-item {
        display: flex;
        padding-top: 20px;
        margin-bottom: 10px;
        // border-bottom: 1px dashed #e9e9e9;
        background: #fff;
        .instance-item-left {
            width: 150px;
            text-align: left;
            padding-top: 3px;
            padding-left: 40px;
            font-size: 12px;
            font-weight: 600;
            .instance-item-icon {
                position: relative;
                right: 6px;
                top: 2px;
                font-size: 14px;
            }
        }
        .instance-item-right {
            width: 850px;
            font-size: 12px;
            padding-right: 15px;
            .show-item {
                margin-bottom: 20px;
                .title {
                    display: inline-block;
                    width: 100px;
                    color: #999;
                    text-align: right;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                    vertical-align: middle;
                }
                .value {
                    display: inline-block;
                    width: calc(~'100% - 100px');
                    position: relative;
                    top: 5px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
}
</style>
